export const infoMessageTemplate = (name) => {
    return (
        `Hi ${name},</br></br>
                <p>Thank you so much for your application to the Godfrey Method On-Demand Teacher Resource Center. To complete your application, we need additional information.
            </br>
            </br>
            To complete your application, please share one or more of the following to verify your educator status:
            </br>
            </br>
            A studio or school website page that lists you as faculty/staff
            </br>
            </br>
            A staff directory or performance/recital program listing your name and role
            </br>
            </br>
            A professional profile (e.g., LinkedIn, Instagram) reflecting your current teaching position
            </br>
            </br>
            You can reply to this email with links or attachments—whatever’s easiest.
            </br>
            </br>
            If you have any questions or need an alternative verification method, just let me know, and we’ll make it simple. We appreciate your time and look forward to welcoming you into the Teacher Resource Center </p>.
       `

    )
}

